export class UserInfo {
  name: String;
  status: String;
  racfId: String;
  employeeName: String;
  modificationStatus: String;
}
